module.exports = "../../app/cells/pages/guides/v2_how_it_works_cell.rb";